import { render, staticRenderFns } from "./arrow.vue?vue&type=template&id=8a990222&scoped=true&"
import script from "./arrow.vue?vue&type=script&lang=js&"
export * from "./arrow.vue?vue&type=script&lang=js&"
import style0 from "./arrow.vue?vue&type=style&index=0&id=8a990222&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a990222",
  null
  
)

export default component.exports